import { defineLocale } from "../../registry";

const basics = defineLocale({
  ru: {
    "basics.section.label": "Основное",
    "basics.group.identity": "Название и категория",
    "basics.group.availability": "Окно доступности",
    "basics.group.ranking": "Порядок показа",
    "basics.group.price": "Цена",
    "basics.group.expect": "Что ожидать",
    "basics.hint.plainText":
      "Только обычный текст: разметка сохраняется и показывается как есть.",
    "basics.hint.utc": "Календарные даты по UTC.",
    "basics.field.title": "Название",
    "basics.field.subtitle": "Подзаголовок",
    "basics.field.category": "Категория",
    "basics.field.icon": "Иконка",
    "basics.field.description": "Описание",
    "basics.field.activityTime": "Время активности",
    "basics.field.sortRank": "Порядок в каталоге",
    "basics.field.featuredOnWorld": "Показывать в World",
    "basics.field.worldRank": "Позиция в World",
    "basics.field.availableFrom": "Доступно с",
    "basics.field.availableUntil": "Доступно до",
    "basics.price.from": "Цена от",
    "basics.price.to": "Цена до",
    "basics.price.openEnded": "Без верхней границы",
    "basics.price.currency": "Валюта",
    "basics.price.unit": "За единицу",
    "basics.price.unitNote": "Пояснение к единице",
    "basics.price.approx": "Примерная цена",
    "basics.price.verifiedAt": "Цена проверена",
    "basics.price.unit.person": "за человека",
    "basics.price.unit.night": "за ночь",
    "basics.price.unit.group": "за группу",
    "basics.price.unit.package": "за пакет",
    "basics.activity.sunrise": "Рассвет",
    "basics.activity.morning": "Утро",
    "basics.activity.midday": "Полдень",
    "basics.activity.afternoon": "День",
    "basics.activity.sunset": "Закат",
    "basics.activity.evening": "Вечер",
    "basics.activity.night": "Ночь",
    "basics.expect.line": "Строка {n}",
    "basics.expect.icon": "Иконка строки {n}",
    "basics.expect.add": "Добавить строку",
    "basics.expect.remove": "Удалить строку {n}",
    "basics.expect.empty": "Строк пока нет",
    "basics.option.none": "Не задано",
    "basics.option.choose": "Выберите значение",
    "basics.option.unknown": "{value} (неизвестное значение)",
    "basics.icon.unknown": "Неизвестная иконка",
    "basics.value.empty": "Не задано",
    "basics.value.yes": "Да",
    "basics.value.no": "Нет",
    "basics.reference.error":
      "Не удалось загрузить справочники категорий и иконок. Доступны только текущие значения.",
    "basics.error.summary":
      "Часть полей заполнена неверно. Исправьте их и сохраните снова.",
    "basics.error.server": "Сервер не принял это значение.",
    "basics.error.required": "Обязательное поле.",
    "basics.error.tooLong": "Не больше {max} символов.",
    "basics.error.invalidDate": "Укажите дату в формате ГГГГ-ММ-ДД.",
    "basics.error.windowInverted": "Не может быть раньше даты начала.",
    "basics.error.notInteger": "Укажите целое число.",
    "basics.error.invalidAmount":
      "Неотрицательная сумма не более чем с двумя знаками после запятой.",
    "basics.error.rangeInverted": "Не может быть меньше нижней границы.",
    "basics.error.openEndedWithUpper":
      "Для цены без верхней границы оставьте поле пустым.",
    "basics.error.invalidCurrency": "Три заглавные буквы, например EUR.",
    "basics.error.invalidChoice": "Выберите значение из списка.",
  },
  en: {
    "basics.section.label": "Basics",
    "basics.group.identity": "Title and category",
    "basics.group.availability": "Availability window",
    "basics.group.ranking": "Display order",
    "basics.group.price": "Price",
    "basics.group.expect": "What to expect",
    "basics.hint.plainText":
      "Plain text only: markup is stored and shown exactly as typed.",
    "basics.hint.utc": "Calendar dates in UTC.",
    "basics.field.title": "Title",
    "basics.field.subtitle": "Subtitle",
    "basics.field.category": "Category",
    "basics.field.icon": "Icon",
    "basics.field.description": "Description",
    "basics.field.activityTime": "Activity time",
    "basics.field.sortRank": "Catalog sort rank",
    "basics.field.featuredOnWorld": "Featured on World",
    "basics.field.worldRank": "World rank",
    "basics.field.availableFrom": "Available from",
    "basics.field.availableUntil": "Available until",
    "basics.price.from": "Price from",
    "basics.price.to": "Price to",
    "basics.price.openEnded": "No upper bound",
    "basics.price.currency": "Currency",
    "basics.price.unit": "Per",
    "basics.price.unitNote": "Unit note",
    "basics.price.approx": "Approximate price",
    "basics.price.verifiedAt": "Price verified on",
    "basics.price.unit.person": "person",
    "basics.price.unit.night": "night",
    "basics.price.unit.group": "group",
    "basics.price.unit.package": "package",
    "basics.activity.sunrise": "Sunrise",
    "basics.activity.morning": "Morning",
    "basics.activity.midday": "Midday",
    "basics.activity.afternoon": "Afternoon",
    "basics.activity.sunset": "Sunset",
    "basics.activity.evening": "Evening",
    "basics.activity.night": "Night",
    "basics.expect.line": "Line {n}",
    "basics.expect.icon": "Line {n} icon",
    "basics.expect.add": "Add line",
    "basics.expect.remove": "Remove line {n}",
    "basics.expect.empty": "No lines yet",
    "basics.option.none": "Not set",
    "basics.option.choose": "Choose a value",
    "basics.option.unknown": "{value} (unknown value)",
    "basics.icon.unknown": "Unknown icon",
    "basics.value.empty": "Not set",
    "basics.value.yes": "Yes",
    "basics.value.no": "No",
    "basics.reference.error":
      "The category and icon lists could not be loaded. Only the current values are available.",
    "basics.error.summary":
      "Some fields are invalid. Fix them and save again.",
    "basics.error.server": "The server did not accept this value.",
    "basics.error.required": "Required.",
    "basics.error.tooLong": "At most {max} characters.",
    "basics.error.invalidDate": "Enter a date as YYYY-MM-DD.",
    "basics.error.windowInverted": "Must not be earlier than the start date.",
    "basics.error.notInteger": "Enter a whole number.",
    "basics.error.invalidAmount":
      "A non-negative amount with at most two decimals.",
    "basics.error.rangeInverted": "Must not be less than the lower bound.",
    "basics.error.openEndedWithUpper":
      "Leave empty for a price without an upper bound.",
    "basics.error.invalidCurrency": "Three capital letters, such as EUR.",
    "basics.error.invalidChoice": "Choose a value from the list.",
  },
});

export default basics;
